var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPlyr)?_c('headerr'):_vm._e(),_c('keep-alive',[_c('router-view')],1),(_vm.showPlyr)?_c('footerr'):_vm._e(),_c('notifications',{attrs:{"group":"foo","position":"bottom left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }